var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.alerts),function(alert,i){return _c('v-alert',{key:i,attrs:{"type":alert.type,"dismissible":""}},[_vm._v(_vm._s(alert.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }